import styled from 'styled-components';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { PAGE_SIZES, PaginationFooter } from 'ui/paginationFooter';
import { colors, spacing } from 'ui/theme';
import { gridLayout, TABLE_COLUMNS } from 'modules/roles/constants';
import { useRolesTable } from 'modules/roles/hooks';
import { TableHeader } from './TableHeader';
import { TableBody } from './TableBody';

const StyledPaginationFooter = styled(PaginationFooter)`
  padding-bottom: ${spacing.base};
  border: none;
  border-top: ${spacing.single} solid ${colors.grey15};
  border-radius: 0 0 ${spacing.half} ${spacing.half};
`;

const TableWrapper = styled.div`
  overflow: auto;
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};
`;

export const RolesTable = () => {
  const {
    currentPage,
    handlePaginationUpdate,
    isLoadingRoles,
    pageSize,
    paginatedRoles,
    rolesLength,
    setSortBy,
    setSortDirection,
    sortBy,
    sortDirection,
  } = useRolesTable();

  return (
    <TableWrapper data-testid="roles-table">
      <TableHeader
        columns={TABLE_COLUMNS}
        gridLayout={gridLayout}
        sortBy={sortBy}
        sortDirection={sortDirection as SORT_DIRECTIONS}
        onSortByChange={setSortBy}
        onSortDirectionChange={setSortDirection}
      />
      <TableBody isLoading={isLoadingRoles} roles={paginatedRoles} />
      {rolesLength > 0 && (
        <StyledPaginationFooter
          currentPage={currentPage}
          itemsPerPage={pageSize}
          numItems={rolesLength}
          onUpdate={handlePaginationUpdate}
          pageSizes={PAGE_SIZES}
        />
      )}
    </TableWrapper>
  );
};
